import $ from 'jquery';
import MpDrawer from '../../../../modules/components/drawer.js';
import { applyComponentClickRestrictions, getOptionsFromDataset } from '../../../../util/dom.js';

/**
 * @param {HTMLElement} trigger
 * @param {*=} options
 */
export default (trigger, options) => {

	$(trigger).on('click.show-selector-drawer', (e) => {

		// Standard component click restrictions
		if (applyComponentClickRestrictions('drawer', options, e) === false) {
			return;
		}

		/**
		 * Merge with drawer options
		 *
		 * @type {import('../../../../modules/components/drawer').MpDrawerStaticOptions}
		 */
		const drawerOptions = {
			disposeOnHide: true,
			...getOptionsFromDataset(trigger, 'drawer', true),
			relatedTarget: trigger,
			skipDataset: true,
		};

		// Display the component
		MpDrawer.show(drawerOptions);
	});
};
